import React from 'react'
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'
import { connect as formikConnect } from 'formik'

export default formikConnect(
  class FormikAutoSave extends React.Component {
    state = {
      isSaving: false,
    }

    componentDidUpdate(prevProps) {
      if (!isEqual(prevProps.formik.values, this.props.formik.values)) {
        this.save()
      }
    }

    save = () => {
      // if (!this.props.formik.isValid) {
      //   return
      // }

      this.setState({ isSaving: true, saveError: undefined }, () => {
        Promise.resolve(this.props.onSave(this.props.formik.values)).then(
          () => this.setState({ isSaving: false, lastSaved: new Date() }),
          (saveError) => this.setState({ isSaving: false, saveError }),
        )
      })
    }

    render() {
      return this.props.render ? this.props.render(this.state) : null
    }
  },
)


// WEBPACK FOOTER //
// ./src/components/FormikAutoSave/FormikAutoSave.jsx